export default __webpack_public_path__ + "4a187e2aade3dd676c538747d3b230d9.ply";